import(/* webpackMode: "eager" */ "/microservice/src/app/error.tsx");
